import React, { useState } from "react";
import CommonHeadPart from "../../common-components/CommonHeadPart";
import { InnerPageRoutes, ROUTES } from "../../constants/routes";
import SettingIcon from "../../svg_icons/Setting.svg";
import { makeStyles } from "@material-ui/core/styles";
import "../Common.css";
import SchoolSetting from "./SchoolSettings/SchoolSetting";
import TexDetails from "./TexDetails/TexDetails";
import WhitelistIps from "./WhitelistIps/WhitelistIps";
import PaymentKey from "./PaymentKey/PaymentKey";
import FilterTabs from "../../common-components/FilterTabs";
import { Settings } from "../../constants/tabs";
import { Box, Card, CardContent } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    divInsideMain: {
        boxShadow: "0 0 5px #8e8e8e",
        borderRadius: "3px",
    },
    divStyling: {
        padding: "15px 20px",
    }
}));

const Setting: React.FC = () => {

    const classes = useStyles();
    const [filter, setFilters] = useState("School Settings");
    const [search, setSearch] = useState('');


    const [value, setValue] = React.useState("1");

    const handleFilter = (newValue: string) => {
        setFilters(newValue);
    };
    const handleSearch = (value: string) => {
        setSearch(value);
    };

    const handleChange = (newValue: string) => {
        setValue(newValue);
    };

    const BreadCrumbDashboard = [
        {
            labelText: "Home",
            linkUrl: ROUTES.home,
        },
        {
            labelText: "Settings",
            linkUrl: ROUTES.settings,
        },
        {
            labelText: filter,
            linkUrl: "",
        },
    ];


    return (
        <>
            <CommonHeadPart
                componentText="Settings"
                Icon={SettingIcon}
                buttonText=""
                // buttonText={filter === "Whitelist Ip's" ? "Add whitelist ip's" : ""}
                urlLink={"/"}
                BreadCrumbs={BreadCrumbDashboard}
            />

            <Card>
                <CardContent>
                    <FilterTabs
                        SelectedFilter={filter}
                        Filters={Settings}
                        HandleChange={handleFilter}
                        isFilter={false}
                        HandleSearch={handleSearch}
                        isSearch={false}
                    />
                </CardContent>
                <div className={classes.divStyling}>
                    {filter === "School Settings" ? <SchoolSetting /> : null}
                    {filter === "Tax (%) Details" ? <TexDetails /> : null}
                    {filter === "Whitelist Ip's" ? <WhitelistIps /> : null}
                    {filter === "Payment Key" ? <PaymentKey /> : null}
                </div>
            </Card>

            {/* <div className={classes.divInsideMain}>
                <FilterTabs
                    SelectedFilter={filter}
                    Filters={Settings}
                    HandleChange={handleFilter}
                    isFilter={false}
                    HandleSearch={handleSearch}
                    isSearch={false}
                />
                <div className={classes.divStyling}>
                    {filter === "School Settings" ? <SchoolSetting /> : null}
                    {filter === "Tax (%) Details" ? <TexDetails /> : null}
                    {filter === "Whitelist Ip's" ? <WhitelistIps /> : null}
                </div>
            </div> */}
        </>
    );
};

export default Setting;
